/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Int32RangeFilter
 */
export interface Int32RangeFilter {
    /**
     * 
     * @type {number}
     * @memberof Int32RangeFilter
     */
    min?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Int32RangeFilter
     */
    max?: number | null;
}

/**
 * Check if a given object implements the Int32RangeFilter interface.
 */
export function instanceOfInt32RangeFilter(value: object): value is Int32RangeFilter {
    return true;
}

export function Int32RangeFilterFromJSON(json: any): Int32RangeFilter {
    return Int32RangeFilterFromJSONTyped(json, false);
}

export function Int32RangeFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): Int32RangeFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
    };
}

export function Int32RangeFilterToJSON(json: any): Int32RangeFilter {
    return Int32RangeFilterToJSONTyped(json, false);
}

export function Int32RangeFilterToJSONTyped(value?: Int32RangeFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'min': value['min'],
        'max': value['max'],
    };
}

